import IframeActivity from "./IframeActivity";

export default function WhatCanILearnFromThis() {
    return (
        <IframeActivity
            src="/activities/what-can-i-learn-from-this/index.html"
            title="What Can I Learn From This?"
        />
    );
}